/* eslint-disable react-refresh/only-export-components */
import * as React from "react";
import { Slot } from "@radix-ui/react-slot";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/lib/utils";
import { CgSpinner } from "react-icons/cg";

const loaderVariants = cva("animate-spin", {
  variants: {
    size: {
      default: "",
      xs: "min-w-4 min-h-4 w-4 h-4",
      sm: "min-w-6 min-h-6 w-6 h-6",
      md: "min-w-8 min-h-8 w-8 h-8",
      lg: "min-w-10 min-h-10 w-10 h-10",
    },
  },
  defaultVariants: {
    size: "default",
  },
});

export interface LoaderProps
  extends React.SVGProps<SVGSVGElement>,
    VariantProps<typeof loaderVariants> {
  asChild?: boolean;
}

const Loader = React.forwardRef<SVGSVGElement, LoaderProps>(
  ({ className, size, asChild = false, ...props }, ref) => {
    const Comp = (asChild ? Slot : CgSpinner) as any;
    return (
      <Comp
        data-component="loader"
        className={cn(loaderVariants({ size, className }))}
        ref={ref as any}
        {...props}
      />
    );
  },
);
Loader.displayName = "Loader";

export { Loader, loaderVariants };
